/**
 * Types of feedback
 */
export enum FeedbackType {
    None,
    Normal,
    Error,
}

/**
 * Feedback form status
 */
export default interface FeedbackFormInfo {
    isFeedbackFormVisible: boolean;
    feedbackType: FeedbackType;
}
